import { LocalStorageWrapper } from "@src/utils/localStorage";
import { UTM_PARAMS_STORAGE_KEY } from "@src/utils/logMarketingPageview";
import { normalizeUtmParams, UTM_PARAM_KEYS, type UtmParams } from "@src/utils/utmParams";

const getUtmParamsFromUrl = (): UtmParams | null => {
  if (typeof window === "undefined") {
    return null;
  }

  const values: Partial<Record<string, string>> = {};
  const searchParams = new URLSearchParams(window.location.search);

  for (const key of UTM_PARAM_KEYS) {
    const value = searchParams.get(key);

    if (value) {
      values[key] = value;
    }
  }

  return normalizeUtmParams(values);
};

const getUtmParamsFromStorage = (): UtmParams | null => {
  const storedUtmParams = LocalStorageWrapper.getItem(UTM_PARAMS_STORAGE_KEY);

  if (!storedUtmParams) {
    return null;
  }

  try {
    return normalizeUtmParams(JSON.parse(storedUtmParams) as Record<string, unknown>);
  } catch {
    return null;
  }
};

export const getTrackedUtmParams = (): UtmParams | null => {
  // First try to get from current URL (handles direct landing with UTM params)
  const urlParams = getUtmParamsFromUrl();
  if (urlParams) {
    return urlParams;
  }

  // Fallback to stored params (handles navigation from previous page with UTM params)
  return getUtmParamsFromStorage();
};
